jQuery(document).ready(function ($) {
    const modal = $('.modal');
    const phoneInput = $('#phone');
    const messageTextarea = document.querySelector('#message');
    const messageTextareaLabel = document.querySelector('label[for="message"]');

    if (messageTextarea) {
        messageTextarea.onfocus = function () {
            messageTextareaLabel.style.color = '#273687';
        }
        messageTextarea.onblur = function () {
            messageTextareaLabel.style.color = 'black';
        }
    }

    let noErrors, phoneInputOldValue, phoneInputOldCursor;

    function phoneInputKeyDownHandler(e) {
        let el = e.target;
        phoneInputOldValue = el.value;
        phoneInputOldCursor = el.selectionEnd;
    }

    function phoneInputInputHandler(e) {
        let el = e.target;
        let newValue = el.value;

        newValue = newValue[0] !== '+' ? newValue.replace(/^/, '+') : newValue;
        let longer = newValue.length > 14;

        el.value = !longer && (newValue.substring(1).match(/^\d+$/) || newValue === ("" || "+"))
            ? newValue : phoneInputOldValue;
    }

    phoneInput.on('keydown', function (e) {
        phoneInputKeyDownHandler(e);
    });

    phoneInput.on('input', function (e) {
        phoneInputInputHandler(e);
    });

    $('.contacts-special-form form').on('submit', function (e) {
        e.preventDefault();

        if ($('.contacts-special-form').hasClass('sended')) {
            return;
        }

        let ask = $('.contacts-special-form').hasClass('ask-frm');

        noErrors = true;

        let skypeOptionalValue = $(this).find('#skype').val();
        let phoneOptionalValue = $(this).find('#phonenumber').val();

        let data = {
            location: window.location.pathname,
            name: getInputValue($(this).find('#yourname')),
            email: getInputValue($(this).find('#youremail')),
            website: getInputValue($(this).find('#website')),
            phone: getInputValue($(this).find('#phone')),
            companyname: getInputValue($(this).find('#companyname')),
            howcanwehelp: getInputValue($(this).find('#howcanwehelp')),
            message: getInputValue($(this).find('#message')),
            skype: skypeOptionalValue == undefined ? '' : skypeOptionalValue,
            phonenumber: phoneOptionalValue == undefined ? '' : phoneOptionalValue
        };

        if (getInputValue($(this).find('#howcanwehelp')) == 'Question regarding an existing order') {
            console.log('need validate orderid');
            data.orderid = getInputValue($(this).find('#orderid'));
        }

        console.log('No errors', noErrors);
        console.log('Data', data);

        if (noErrors) {

            $('.contacts-special-form').addClass('sended');
            $('.contacts-special-form button').prop('disabled', true);
            $('.contacts-special-form button span').text('Sending');

            // if (typeof loadedRecaptcha != 'undefined') {
            //     return;
            // }
            $.getScript("https://www.google.com/recaptcha/api.js?render=6LcGS8EhAAAAAGaEvbXZRkNxV8mtisTqFvtMt8JK")
                .done(function (script, textStatus) {
                    if (typeof grecaptcha !== "undefined") {
                        grecaptcha.ready(function () {
                            grecaptcha.execute('6LcGS8EhAAAAAGaEvbXZRkNxV8mtisTqFvtMt8JK', { action: 'submit' })
                                .then(function (token) {
                                    $.ajax({
                                        method: 'POST',
                                        url: '/wp-json/captcha/verify/',
                                        data: { token: token },
                                        success: function (response) {
                                            console.log(response);
                                            if (response) {
                                                let url = '/wp-json/send_email/send/';
                                                $.ajax({
                                                    method: 'POST',
                                                    url: url,
                                                    data: {
                                                        data
                                                    },
                                                    success: function (response) {
                                                        console.log(response);
                                                        $('.contacts-special-form form').trigger("reset");
                                                        $('.contacts-special-form').removeClass('sended');
                                                        $('.contacts-special-form button span').text('Sent');
                                                        $('.contacts-special-form button').prop('disabled', false);
                                                        $(modal).addClass('active');
                                                    }
                                                });
                                            }
                                        }
                                    });
                                });
                        });
                    }
                    //loadedRecaptcha = true;
                });
        }
    });

    function sendingEmail() {

    }

    function validateInput(id, value) {
        const patterns = {
            yourname: /^([A-Za-z. \'-]{0,55})$/,
            companyname: /^\D*$/,
            youremail: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
            phone: /^\+?[1-9][0-9]{10,12}$/,
            message: /^(?!\s*$).+/,
            howcanwehelp: /[\w\s]+/,
            orderid: /^\d+$/,
            living: /[\w\s]+/,
            citizenship: /[\w\s]+/,
            website: /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi
        };


        return id in patterns ? patterns[id].test(value) : true;
    }

    function getInputValue(el) {
        if (!el.length) {
            return '';
        }

        let errorMessage = $(el).siblings('.input_error');
        let id = $(el).attr('id');

        if (id === 'message') {
            $(el).val().replace(/(<([^>]+)>)/gi, "");
        }

        let inputValue = $(el).val().trim();

        if ((!validateInput(id, inputValue)) || (inputValue.length === 0)) {
            noErrors = false;
            $(el).addClass('error');
            $(el).siblings('label').addClass('error');
            $(errorMessage).show();
            return '';
        } else {
            $(el).removeClass('error');
            $(el).siblings('label').removeClass('error');
            $(errorMessage).hide();
            return $(el).val();
        }
    }

    $('#howcanwehelp').on('change', function () {
        $('.contacts-special-form .order-id').toggle(getInputValue(this) == 'Question regarding an existing order');
    });

    let modalClose = $('.has-modal-close-btn  a.modal-close-btn');
    modalClose.click(function (e) {
        e.preventDefault();
        $('.contacts-special-form button span').text('Send');

        form = $(this).parents('.has-modal-close-btn');
        $(form).removeClass('active');
    });

    // let modalMPClose = $('.modal-make-a-payment .modal-make-a-payment__btn > a');
    // modalMPClose.click(function (e) {
    //     e.preventDefault();
    //     $('.modal-make-a-payment').removeClass('active');
    // });

    // let modalMEClose = $('.modal-redirect-error .modal-redirect-error__btn > a');
    // modalMEClose.click(function (e) {
    //     e.preventDefault();
    //     $('.modal-redirect-error').removeClass('active');
    // });

    // let modalIDClose = $('.modal-cannot-find-order-ID .modal-cannot-find-order-ID__btn > a');
    // modalIDClose.click(function (e) {
    //     e.preventDefault();
    //     $('.modal-cannot-find-order-ID').removeClass('active');
    // });
});